// @flow
import React, { Component } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { decode } from "../utils/string";

import { isCD } from "../rest/utils/envDetection";

import {
    Header,
    HeaderContent,
    HeaderText,
    SearchBox,
    CdSearchBox,
    SearchArea,
    SearchResult,
    SearchResults,
    CdSearchResults
} from "./styled";

type Props = {|
    userInfo: Object,
    searchResults: Array,
    onSearch: Function,
    onShowBlog: Function
|};

class PageHeaderView extends Component<Props> {
    // Init of the component before it is mounted.
    constructor(props) {
        super(props);

        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }
    // Add listeners immediately after the component is mounted.
    componentDidMount() {
        window.addEventListener("keyup", this.handleKeyUp, false);
        document.addEventListener("mousedown", this.handleOutsideClick);
    }

    // Remove listeners immediately before a component is unmounted and destroyed.
    componentWillUnmount() {
        window.removeEventListener("keyup", this.handleKeyUp, false);
        document.removeEventListener("mousedown", this.handleOutsideClick);
    }

    search = e => {
        this.props.onSearch(e.target.value);
    };

    select = blog => {
        this.props.onShowBlog(blog);
        this.props.onSearch("");
    };

    // Handle the mouse click on browser window.
    handleOutsideClick(e) {
        const thisComponent =
            e.target.className &&
            e.target.className.indexOf &&
            e.target.className.indexOf("search-result") >= 0;
        if (!thisComponent) {
            this.props.onSearch("");
        }
    }

    // Handle the key press event.
    handleKeyUp(e) {
        const textBox =
            e.target.className &&
            e.target.className.indexOf &&
            e.target.className.indexOf("search-box") >= 0;
        if (textBox) {
            const keys = {
                27: () => {
                    e.preventDefault();
                    this.props.onSearch("");
                },
                13: () => {
                    this.search(e);
                    e.preventDefault();
                }
            };
            if (keys[e.keyCode]) {
                keys[e.keyCode]();
            }
        }
    }
    render() {
        const { searchResults, userInfo } = this.props;

        const searchResultsItems = [];
        if (searchResults) {
            for (let i = 0; i < searchResults.length && i < 10; i += 1) {
                searchResultsItems.push(
                    <SearchResult
                        className="search-result"
                        key={searchResults[i].id}
                        onClick={() => this.select(searchResults[i])}
                    >
                        {decode(searchResults[i].title)}
                    </SearchResult>
                );
            }
        }

        const SearchInput = isCD ? CdSearchBox : SearchBox;
        const SearchDropdown = isCD ? CdSearchResults : SearchResults;
        const searchIconLeft = isCD ? 38 : 218;

        return (
            <div>
                <Header />

                <HeaderContent>
                    {!isCD && (
                        <HeaderText href="https://www.getjealous.com">GetJealous.com</HeaderText>
                    )}
                    <SearchArea>
                        <SearchInput
                            className="search-box"
                            onChange={this.search}
                            placeholder={`Search ${
                                userInfo && userInfo.length > 0 ? userInfo[0].title : ""
                            }`}
                        />
                        <SearchIcon
                            style={{ left: searchIconLeft, position: "absolute", top: 13 }}
                        />
                        {searchResultsItems.length > 0 && (
                            <SearchDropdown className="search-results">
                                {searchResultsItems}
                            </SearchDropdown>
                        )}
                    </SearchArea>
                </HeaderContent>
            </div>
        );
    }
}

export default PageHeaderView;



// WEBPACK FOOTER //
// ./src/header-view/view.js